<template>
    <div v-if='contact' >
        <div class="Modal__header">
            <h3>Supprimer le participant ?</h3>
        </div>

        <div class="Modal__body"  >
            <p>Vous êtes sur le point de supprimer définitivement le participant {{ contact.leader_firstname }} {{ contact.leader_lastname }}</p>
            <p>Toutes les données relatives à ce participant seront également supprimées.</p>
        </div>

        <div class="Modal__footer">
            <button class="Modal__buton-ok" @click="cancel()">
                Annuler
            </button>
            <button class="Modal__buton-danger" @click="confirm()">
                Supprimer
            </button>
        </div>
    </div>
</template>

<script>
    /* See https://adamwathan.me/2016/01/04/composing-reusable-modal-dialogs-with-vuejs/ */
    import { deleteContact } from '../../vuex/actions/contactActions'

    export default{
      props: ['contact'],
      vuex: {
        actions: {
          deleteContact
        }
      },
      data () {
        return {}
      },
      methods: {
        cancel () {
          this.$dispatch('closeModal')
        },
        confirm () {
          this.deleteContact(this.contact)
          this.$dispatch('closeModal')
          this.$dispatch('preview-data', [])
        }
      }
}
</script>



// WEBPACK FOOTER //
// DeleteContact.vue?5230de90